"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browserCookieWrapper_1 = require("./browserCookieWrapper");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
exports.OPT_IN_COOKIE_NAME = 'OptInPrg';
function isClientOptingReact() {
    return isClientOpting(2 /* React */);
}
exports.isClientOptingReact = isClientOptingReact;
function isClientOptingJsmvvm() {
    return isClientOpting(1 /* Jsmvvm */);
}
exports.isClientOptingJsmvvm = isClientOptingJsmvvm;
function isClientOpting(client) {
    var optinCookieValue = browserCookieWrapper_1.getCookie(exports.OPT_IN_COOKIE_NAME);
    return optinCookieValue == '' + client;
}
function optIntoJsmvvmClient() {
    updateClientOptInStateCookie(1 /* Jsmvvm */);
}
exports.optIntoJsmvvmClient = optIntoJsmvvmClient;
function optIntoJsmvvmClientAndRedirect(modulePath) {
    optIntoJsmvvmClient();
    var sessionType = getUserConfiguration_1.default().SessionSettings.WebSessionType;
    var redirectPath = '/owa/';
    var params = [];
    if (sessionType) {
        params.push('isc=' + sessionType);
    }
    if (modulePath) {
        params.push(modulePath);
    }
    if (params.length > 0) {
        redirectPath = redirectPath + '?' + params.join('&');
    }
    location.assign(redirectPath);
}
exports.optIntoJsmvvmClientAndRedirect = optIntoJsmvvmClientAndRedirect;
function updateClientOptInStateCookie(value) {
    if (value == null) {
        browserCookieWrapper_1.updateCookie(exports.OPT_IN_COOKIE_NAME);
    }
    else {
        browserCookieWrapper_1.updateCookie(exports.OPT_IN_COOKIE_NAME, '' + value, { path: '/' });
    }
}
exports.updateClientOptInStateCookie = updateClientOptInStateCookie;
//# sourceMappingURL=mailOptinUtility.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-optin/lib/utils/mailOptinUtility.js
// module id = 2930
// module chunks = 45 62